var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"your-reports-wrapper"},[_c('div',{staticClass:"your-reports"},[_c('div',{staticClass:"your-reports-main-content"},[_c('div',{staticClass:"fs-24 t-fs-20 bold-600 mb-2"},[_vm._v(" Your Reports ")]),_c('div',{staticClass:"your-reports-table-wrapper"},[_c('ReportHistoryTable',{attrs:{"rows-per-page":10}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }